/**
 * Tabs component type definitions
 */

export enum TabsSize {
  Small = 'sm',
  Default = 'default',
  Large = 'lg',
}

export enum TabsVariant {
  Default = 'default',
  Pills = 'pills',
  Underline = 'underline',
}

export enum TabsOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
